import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { GradeLevelService } from "../report-services/grade-level.service";
import { AcademyService } from "../report-services/academy.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	templateUrl: "./photolabels.component.html",
})
export class PhotoLabelsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		GradeLevelID: 0,
		AcademyID: 0,
		HomeroomID: 0,
		ORDERBYID: "Academy",
		W_ID: "Yes",
		W_HPhoneID: "Yes",
		W_HRoomID: "Yes",
		W_DOBID: "Yes",
		W_NameID: "Yes",
	};
	//Insert Custom Lists Here
	schoolList: any = [];
	GradeLevelList: any = [];
	AcademyList: any = [];
	HomeroomList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ORDERBYList = [
		//Insert Custom List Items Here
		{
			ORDERBYName: "Academy",
		},
		{
			ORDERBYName: "Grade",
		},
		{
			ORDERBYName: "Homeroom",
		},
		{
			ORDERBYName: "Name",
		},
	];

	W_List = [
		//Insert Custom List Items Here
		{
			W_ID: "Yes",
		},
		{
			W_ID: "No",
		},
	];

	W_HPhoneList = [
		//Insert Custom List Items Here
		{
			W_HPhoneID: "Yes",
		},
		{
			W_HPhoneID: "No",
		},
	];

	W_HRoomList = [
		//Insert Custom List Items Here
		{
			W_HRoomID: "Yes",
		},
		{
			W_HRoomID: "No",
		},
	];

	W_DOBList = [
		//Insert Custom List Items Here
		{
			W_DOBID: "Yes",
		},
		{
			W_DOBID: "No",
		},
	];

	W_NameList = [
		//Insert Custom List Items Here
		{
			W_NameID: "Yes",
		},
		{
			W_NameID: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 222;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadGradeLevelList()
		// this.loadAcademyList()
		// this.loadHomeroomList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevelList();
		this.loadAcademyList();
		this.loadHomeroomList();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(222);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadAcademyList() {
		this.report.AcademyID = 0;
		var result = this.academyService.loadAcademyList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				if (this.AcademyList.length > 1) {
					// this.AcademyList.unshift({
					//     AcademyId: 0,
					//     AcademyDesc: "All Academys"
					// })
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				} else {
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					// this.HomeroomList.unshift({
					//     HomeroomId: 0,
					//     HomeRoom: "All Homerooms"
					// })
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.GradeLevelID) {
		// 	this.errorMessage = "Select the GradeLevel"
		// 	return;
		// }

		// if (!this.report.AcademyID) {
		// 	this.errorMessage = "Select the ACADEMY"
		// 	return;
		// }

		// if (!this.report.HomeroomID) {
		// 	this.errorMessage = "Select the HOMEROOM"
		// 	return;
		// }

		// if (!this.report.ORDERBYID) {
		// 	this.errorMessage = "Select the ORDERBY"
		// 	return;
		// }

		// if (!this.report.W_ID) {
		// 	this.errorMessage = "Select the W_"
		// 	return;
		// }

		// if (!this.report.W_HPhoneID) {
		// 	this.errorMessage = "Select the W_HPhone"
		// 	return;
		// }

		// if (!this.report.W_HRoomID) {
		// 	this.errorMessage = "Select the W_HRoom"
		// 	return;
		// }

		// if (!this.report.W_DOBID) {
		// 	this.errorMessage = "Select the W_DOB"
		// 	return;
		// }

		// if (!this.report.W_NameID) {
		// 	this.errorMessage = "Select the W_Name"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 222;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 3: ACADEMYID
		strParam += "," + this.report.AcademyID + "|AcademyID";

		//Parameter 4: HOMEROOMID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//Parameter 5: ORDERBY
		strParam += "," + this.report.ORDERBYID + "|OrderBy";

		//Parameter 6: W_ID
		strParam += "," + this.report.W_ID + "|W_ID";

		//Parameter 7: W_HPhone
		strParam += "," + this.report.W_HPhoneID + "|W_HPhone";

		//Parameter 8: W_HRoom
		strParam += "," + this.report.W_HRoomID + "|W_HRoom";

		//Parameter 9: W_DOB
		strParam += "," + this.report.W_DOBID + "|W_DOB";

		//Parameter 10: W_Name
		strParam += "," + this.report.W_NameID + "|W_Name";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
